import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import buildher1 from './pictures/buildher1.jpg';
import buildher2 from './pictures/buildher2.jpg';
import buildher3 from './pictures/buildher3.jpg';
import buildher4 from './pictures/buildher4.JPG';
import buildher5 from './pictures/buildher5.jpg';

const Buildher = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC x cseed BuildHER Italian Soda Chats!</h2>
                    <p class="site-post-meta">February 13, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                
                    Thank you so much for attending our Italian Soda Chats Event with cseed BuildHER! We had an enthralling evening of discussions with our lovely mentors over freshly made Italian Soda! Our mentors included an amazing line-up of women leaders, including Keona Moy, the founder of VKTORI, Melinda Haughey, the co-founder of Proxi, and Michaela Isaacs, a leader at YoungTech and incoming Product Manager at Microsoft. It was so inspirational chatting with these women, learning about their journeys from college to where they are today, and gaining invaluable advice in the process. 

                    </p>
                    <img src={buildher1} alt="pic1 "/>
                    <img src={buildher2} alt="pic2"/>
                    <img src={buildher3} alt="pic4"/>
                    <img src={buildher4} alt="pic5"/>
                    <img src={buildher5} alt="pic6"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Buildher;
